const Footer = () => {
  return (
    <div className="footer font">
      <div className="footer-text">
        Connectify by freemulder - 2023 - Zones de Genie
      </div>
    </div>
  );
};

export default Footer;
